export default __webpack_public_path__ + "8cc172164c23f323b0265683480ce68a.mov";